import React from 'react';

import withTranslations from '../../utils/translations/withTranslations';

export const OptionalLabel = withTranslations(({ translate }) => {
  return (
    <label className="Form__OptionalLabel Form__OptionalLabel">
      {translate('optional')}
    </label>
  )
})

